module.exports = __webpack_public_path__ + "static/img/apl digital.16c6dcb4.png";